import React, { useState } from "react";
import { getScaleValues } from "utils/scales";

export interface EstimatePanelProps {
  estimationType: string;
  customValues?: string[];
  onVote: (vote: string | number) => void;
  selectedVote?: string | number | null;
  isRevealed: boolean;

  className?: string;
  classes?: {
    root?: string;
    grid?: string;
    button?: string;
    buttonSelected?: string;
  };
}

const EstimatePanel: React.FC<EstimatePanelProps> = ({
  estimationType,
  customValues,
  onVote,
  selectedVote,
  isRevealed,
  className,
  classes = {},
}) => {
  const values = getScaleValues(estimationType, customValues);
  const rootClass = [classes.root, className].filter(Boolean).join(" ");
  const gridClass = [classes.grid].filter(Boolean).join(" ");

  return (
    <div className={rootClass}>
      <div className={gridClass}>
        {values.map((value) => {
          const isSelected = selectedVote?.toString() === value;
          const btn = [classes.button, isSelected && classes.buttonSelected].filter(Boolean).join(" ");

          return (
            <button
              key={String(value)}
              className={btn}
              onClick={() => onVote(value)}
              type="button"
              disabled={isRevealed}
            >
              {String(value)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EstimatePanel;
